import React, { useContext } from 'react';
import '../styles/Home.css';
import { LanguageContext } from '../components/LanguageContext';
import translations from '../locales/home.json';

export default function Home() {
    const { language } = useContext(LanguageContext);
    const { title, subtitle } = translations[language].home;

    // Разбиваем subtitle на абзацы
    const paragraphs = subtitle.split('\n');

    return (
        <div className="home-wrapper">
            <video
                className="background-video"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src="/videos/66.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="overlay" />

            <div className="home-card">
                <h1 className="home-title">{title}</h1>
                {paragraphs.map((text, idx) => (
                    <p key={idx} className="home-paragraph">
                        {text}
                    </p>
                ))}
            </div>
        </div>
    );
}